import React from "react";
import "../styles/about.css";
import Navbar from "../components/layout/Navbar";
import suneelImage from "../assets/suneel.jpeg";
import SeoHead from "../components/SeoHead";
export default function AboutPage() {
  return (
    <div className="ab-page">

      <SeoHead
        title="About Dr. R. Suneel — Hand & Wrist Surgeon, Hyderabad"
        description="Dr. R. Suneel is a fellowship-trained hand & wrist surgeon with 15+ years of experience and 7500+ surgeries. Learn about his training and approach."
        keywords="about Dr R Suneel, hand surgeon Hyderabad, fellowship trained hand surgeon, wrist specialist Hyderabad"
        url="https://www.handandwristclinics.com/about"
        image="https://www.handandwristclinics.com/static/media/hand_surgery.png"
      />

      <header className="ab-hero">
        <div className="ab-hero-inner">
          <nav className="ab-breadcrumb" aria-label="Breadcrumb">
            <a href="/">Home</a>
            <span className="ab-bc-sep">/</span>
            <span className="ab-bc-current">About</span>
          </nav>

          <div className="ab-eyebrow">
            <span></span> Meet the Specialist
          </div>

          <h1 className="ab-title">
            Dr. R. Suneel <em>About</em>
          </h1>

          <div className="ab-divider" />

          <p className="ab-hero-sub">
            Dedicated to advanced hand, wrist, and peripheral nerve surgery with a
            patient-first approach.
          </p>
        </div>
      </header>

      <section className="ab-section ab-profile">
        <div className="ab-container">
          <div className="ab-profile-grid">

            <div className="ab-img-wrap">
              <div className="ab-img-main">
                <img src={suneelImage} alt="Dr. R. Suneel" />
              </div>
            </div>

            <div className="ab-bio">
              <div className="ab-section-tag">Professional Profile</div>

              <h2 className="ab-section-title">
                Expert care in <em>hand and wrist surgery</em>
              </h2>

              <div className="ab-divider" />

              <p className="ab-bio-text">
                Hand surgery has evolved over time into a speciality with focus on Hand, Wrist, Peripheral nerve and Brachial plexus disorders. Most of these problems were thought to have poor outcome and were not properly taken care of, but considering the extraordinary complex structure of hand and importance in daily activities most of the patients would land up with disability and poor functional and aesthetic outcome.
              </p>

              <p className="ab-bio-text">
                Treating these disorders needs exemplary skill, patience and comprehensive understanding of the patients need and in this regard, Dr.R.Suneel who did his Fellowship In Hand & Reconstructive Microsurgery from prestigious Christian Medical College, Vellore had vast experience in his speciality and would be a great asset to his patients.
              </p>

              <p className="ab-bio-text">
                We at Hand and Wrist clinics - provide with one of its kind dedicated Hand surgery services including emergency care
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}